/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import classes from "./main.module.css";
import constants from "../../../../helper/constants";
import placeholderImage from "../../../../asset/images/image_placeholder.png";
import { DefaultImage } from "../../../../helper/setFallbackImages";

const Carousel = (props) => {
  const [imageIndex, setImageIndex] = useState(0);
  return (
    <>
      <div className={classes.featuredImageWrapper}>
        <div className={classes.featuredImage}>
          {props.images[imageIndex] ? (
            <img
              onError={DefaultImage}
              src={`${constants.imageUrl}${props.images[imageIndex]}`}
              alt={props.images[imageIndex]}
              style={{ objectFit: "contain", borderRadius: "4px" }}
            />
          ) : (
            <img onError={DefaultImage} src={""} alt={"placeholder"} />
          )}
        </div>
        <ul className={classes.imagesList}>
          {props.images.map(
            (image, index) =>
              image && (
                <li
                  onClick={() => {
                    setImageIndex(index);
                  }}
                  key={index}
                  style={{ borderColor: props.color }}
                >
                  <img
                    onError={DefaultImage}
                    alt={image}
                    src={constants.imageUrl + image}
                  />
                </li>
              ),
          )}
        </ul>
      </div>
    </>
  );
};

export default Carousel;
